import FlexSelect from 'components/Inputs/FlexSelect';
import ChatBroadcastListService from 'views/ChatBroadcastList/service';
import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Button, Col, Input, Row } from 'reactstrap';
import { emailRegex, typeFieldsProtocol } from './utils';
import { ErrorMessage } from '@hookform/error-message';
import {
  ButtonDeleteFieldArea,
  FieldValueProtocolArea,
  FieldValueProtocolTotalArea
} from '../../styled';
import { TYPES_BROADCAST_LIST } from 'views/ChatBroadcastList/utils';
import { Loading } from 'views/Report/Audit/Authentication/components/Loading';
import { HandlerBroadcastListProtocolCustomFields } from './CustomFields/HandlerCustomFilterProtocol';

const { TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL } = TYPES_BROADCAST_LIST;

export const ProtocolFieldsBroadcastList = ({
  setValue,
  control,
  errors,
  selectedOption,
  selectedRecordType,
  watch,
  isUpdate = false
}) => {
  const [status, setStatus] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [subReasons, setSubReasons] = useState([]);
  const [loadingSubReasons, setLoadingSubReasons] = useState(false);
  const [loading, setLoading] = useState(false);
  const [protocolFields, setProtocolFields] = useState([]);
  const [protocolFieldsInUse, setProtocolFieldsInUse] = useState([]);
  const [optionsCustomFields, setOptionsCustomFields] = useState({});
  const [isCustomFieldRender, setIsCustomFieldRender] = useState(true);

  const isTypeBroadcastListCorrect =
    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ||
    selectedOption === 'CREATE_PROTOCOL';

  const fieldsNameToRemove = [
    'client_id',
    'files',
    'service_channel',
    'account_id',
    'current_responsible'
  ];

  const handlerGetReasons = async (recordTypeId) => {
    const response = await ChatBroadcastListService.getReasons(recordTypeId);

    return setReasons(
      response.map((reason) => ({
        label: reason.name,
        value: reason.id
      }))
    );
  };
  useEffect(() => {
    if (isUpdate) {
      handlerGetReasons(selectedRecordType);
      handleGetSubReasons(watch('protocol.reason_id.value'));
    }
  }, [isUpdate]);

  const handleGetSubReasons = async (event) => {
    setLoadingSubReasons(true);
    let value = '';
    if (event && event.target) {
      value = event.target.value;
    } else {
      value = event;
    }

    const response = await ChatBroadcastListService.getSubReasons(value);
    setSubReasons(response);
    setLoadingSubReasons(false);
  };

  const handlerAddFieldProtocol = (index, name) => {
    const fieldsProtocolCopy = [...protocolFields];
    const fieldsInUseCopy = [...protocolFieldsInUse];

    const fieldCurrentName = fieldsInUseCopy[index].name;

    const fieldCurrentIndex = fieldsProtocolCopy.findIndex(
      (field) => field.name === fieldCurrentName
    );

    if (fieldCurrentIndex >= 0) {
      fieldsProtocolCopy[fieldCurrentIndex].isSelected = false;
    }

    const newFieldSelectedIndex = fieldsProtocolCopy.findIndex(
      (field) => field.name === name
    );

    fieldsInUseCopy[index] = {
      ...fieldsProtocolCopy[newFieldSelectedIndex],
      isSelected: true
    };

    fieldsProtocolCopy[newFieldSelectedIndex].isSelected = true;

    setProtocolFields(fieldsProtocolCopy);
    setProtocolFieldsInUse(fieldsInUseCopy);
  };

  const handlerRemoveFieldProtocol = (index) => {
    const fieldToDelete = { ...protocolFieldsInUse[index] };
    const fieldsProtocolInUseCopy = [...protocolFieldsInUse];
    fieldsProtocolInUseCopy.splice(index, 1);
    setProtocolFieldsInUse(fieldsProtocolInUseCopy);

    const protocolFieldsCopy = [...protocolFields];

    const fieldIndex = protocolFieldsCopy?.findIndex(
      (field) => field.name === fieldToDelete?.name
    );
    if (fieldIndex >= 0) {
      protocolFieldsCopy[fieldIndex].isSelected = false;
      setProtocolFields(protocolFieldsCopy);
    }
  };

  const handlerAddNewCustomField = () => {
    setProtocolFieldsInUse((prev) => [
      ...prev,
      {
        label: 'Selecionar...',
        name: 'free',
        isRequired: false,
        isSelected: true,
        isDefault: false,
        type: 'TEXT'
      }
    ]);
  };

  const mapDefaultFieldName = (fieldName) => {
    switch (fieldName) {
      case 'account_id':
        return 'Conta';
      case 'client_id':
        return 'Cliente';
      case 'current_responsible':
        return 'Responsável';
      case 'current_status':
        return 'Status';
      case 'description':
        return 'Descrição';
      case 'email':
        return 'Email';
      case 'service_channel':
        return 'Canal de atendimento';
      case 'reason_id':
        return 'Motivo';
      case 'subreason_id':
        return 'Submotivo';
      case 'telephone':
        return 'Telefone';
      case 'title':
        return 'Título';
      default:
        return '';
    }
  };

  const getProtocolFields = async (recordTypeId) => {
    setLoading(true);
    const [customFields, defaultFields] = await Promise.all([
      getCustomFieldProtocol(recordTypeId),
      getDefaultFieldsProtocol(recordTypeId)
    ]);

    if (
      defaultFields.reason_id?.isRequired &&
      isTypeBroadcastListCorrect &&
      selectedRecordType
    ) {
      await handlerGetReasons(selectedRecordType);
      setValue('protocol.reason_id.type', 'default_values');
      setValue('protocol.subreason_id.type', 'default_values');
    }

    if (
      defaultFields.current_status?.isRequired &&
      isTypeBroadcastListCorrect &&
      selectedRecordType
    ) {
      await handleGetStatus(selectedRecordType);
      setValue('protocol.current_status.type', 'default_values');
    }

    let fieldsInUse = [];

    const defaultFieldFormatted = Object.keys(defaultFields).flatMap(
      (fieldName) => {
        const field = defaultFields[fieldName];
        const isRequired = field.isRequired && field.isActive;

        if (fieldsNameToRemove.includes(fieldName)) return [];

        const update = watch(`protocol.${fieldName}.value`) && !isRequired;
        if (update) {
          fieldsInUse.push({
            label: mapDefaultFieldName(fieldName),
            name: fieldName,
            isRequired: false,
            isSelected: true,
            isDefault: true,
            type: 'DEFAULT'
          });
        }
        if (isRequired) {
          setValue(`protocol.${fieldName}.label`, fieldName);
          fieldsInUse.push({
            label: mapDefaultFieldName(fieldName),
            name: fieldName,
            isRequired: isRequired,
            isSelected: isRequired,
            isDefault: true,
            type: 'DEFAULT'
          });
        }
        return {
          label: mapDefaultFieldName(fieldName),
          name: fieldName,
          isRequired: isRequired,
          isSelected: update ? true : isRequired,
          isDefault: true,
          type: 'DEFAULT'
        };
      }
    );

    const optionsFields = {};
    const customFieldFormatted = customFields.flatMap((field) => {
      const isRequired =
        field.recordTypesConfig.isActive && field.recordTypesConfig.isRequired;

      if (field.type === 'LIST') {
        const options = field.options.map((option) => {
          return {
            label: option.value,
            value: option.value
          };
        });

        optionsFields[field.name] = options;
      }

      const update =
        watch(`protocol.${field.name}.value`) && !isRequired && isUpdate;
      if (update) {
        fieldsInUse.push({
          label: mapDefaultFieldName(field.name),
          name: field.name,
          isRequired: false,
          isSelected: true,
          isDefault: false,
          type: field.type
        });
      }

      if (isRequired) {
        fieldsInUse.push({
          label: field.label,
          name: field.name,
          isRequired,
          isSelected: isRequired,
          isDefault: false,
          type: field.type
        });
      }
      return {
        label: field.label,
        name: field.name,
        isRequired,
        isSelected: update ? true : isRequired,
        isDefault: false,
        type: field.type
      };
    });

    const allFields = [...defaultFieldFormatted, ...customFieldFormatted];

    setProtocolFields(allFields);
    setOptionsCustomFields(optionsFields);
    setProtocolFieldsInUse(fieldsInUse.sort((a) => a.isDefault));
    setLoading(false);
  };

  const getCustomFieldProtocol = async (recordTypeId) => {
    const response =
      await ChatBroadcastListService.getProtocoloCustomFieldsByRecordType(
        recordTypeId
      );

    return response;
  };

  const getDefaultFieldsProtocol = async (recordTypeId) => {
    const response =
      await ChatBroadcastListService.getProtocolFieldsDefaultByRecordType(
        recordTypeId
      );

    return response;
  };

  const handleGetStatus = async (recordTypeId) => {
    const response = await ChatBroadcastListService.getStatus(recordTypeId);
    setStatus(response);
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  useEffect(() => {
    if (selectedRecordType) {
      getProtocolFields(selectedRecordType);
    }
  }, [selectedRecordType]);

  return (
    <div>
      <label className="form-control-label">Campos do protocolo</label>
      <Row>
        {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
          <Col>
            <label className="form-control-label">Tipo*</label>
          </Col>
        ) : null}
        <Col>
          <label className="form-control-label">Campo*</label>
        </Col>
        <Col>
          <label className="form-control-label">Valor*</label>
        </Col>
      </Row>

      {!loading && protocolFields.length > 0 ? (
        protocolFieldsInUse.map((field, index) => {
          if (!field.isSelected) return null;
          if (field.name === 'title') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={typeFieldsProtocol || []}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          valueController={setValue}
                          fieldName="protocol.title.type"
                          labelName="label"
                          valueName="value"
                        />
                      )}
                      control={control}
                      name="protocol.title.type"
                      rules={{ required: 'Campo obrigatório' }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.title.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Titulo',
                            value: 'title'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="title"
                        valueController={setValue}
                        fieldName="protocol.title.label"
                        labelName="label"
                        valueName="value"
                        defaultValue="title"
                      />
                    )}
                    defaultValue="title"
                    name="protocol.title.label"
                    control={control}
                    disabled={field.isRequired}
                    rules={{ required: 'Campo obrigatório' }}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        as={Input}
                        name="protocol.title.value"
                        control={control}
                        disabled={
                          watch('protocol.title.type') === 'first_answer'
                        }
                        rules={
                          watch(`protocol.title.type`) !== 'first_answer' && {
                            required: 'Campo obrigatório'
                          }
                        }
                      />
                      <ErrorMessage
                        errors={errors}
                        name="protocol.title.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        disabled={field.isRequired}
                        title={'Excluir campo'}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'telephone') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={typeFieldsProtocol}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          valueController={setValue}
                          fieldName="protocol.telephone.type"
                          labelName="label"
                          valueName="value"
                        />
                      )}
                      control={control}
                      name="protocol.telephone.type"
                      rules={{ required: 'Campo obrigatório' }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.telephone.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Telefone',
                            value: 'telephone'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="telephone"
                        valueController={setValue}
                        fieldName="protocol.telephone.label"
                        labelName="label"
                        valueName="value"
                      />
                    )}
                    defaultValue="telephone"
                    name="protocol.telephone.label"
                    control={control}
                    disabled={field.isRequired}
                    rules={{ required: 'Campo obrigatório' }}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        as={Input}
                        name="protocol.telephone.value"
                        control={control}
                        disabled={
                          watch(`protocol.telephone.type`) === 'first_answer'
                        }
                        rules={
                          watch(`protocol.telephone.type`) !==
                            'first_answer' && {
                            required: 'Campo obrigatório'
                          }
                        }
                      />
                      <ErrorMessage
                        errors={errors}
                        name="protocol.telephone.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        disabled={field.isRequired}
                        title={'Excluir campo'}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'description') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={typeFieldsProtocol}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          valueController={setValue}
                          fieldName="protocol.description.type"
                          labelName="label"
                          valueName="value"
                        />
                      )}
                      control={control}
                      name="protocol.description.type"
                      rules={{ required: 'Campo obrigatório' }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.description.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Descrição',
                            value: 'description'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="description"
                        valueController={setValue}
                        fieldName="protocol.description.label"
                        labelName="label"
                        valueName="value"
                      />
                    )}
                    defaultValue="description"
                    name="protocol.description.label"
                    control={control}
                    disabled={field.isRequired}
                    rules={{ required: 'Campo obrigatório' }}
                  />
                </Col>

                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        as={Input}
                        name="protocol.description.value"
                        control={control}
                        disabled={
                          watch('protocol.description.type') === 'first_answer'
                        }
                        rules={
                          watch(`protocol.description.type`) !==
                            'first_answer' && {
                            required: 'Campo obrigatório'
                          }
                        }
                      />
                      <ErrorMessage
                        errors={errors}
                        name="protocol.description.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        title={'Excluir campo'}
                        disabled={field.isRequired}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'reason_id') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={() => (
                        <FlexSelect
                          dataOptions={[
                            {
                              label: 'Valor padrão',
                              value: 'default_values'
                            }
                          ]}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value="default_values"
                          valueController={setValue}
                          fieldName="protocol.reason_id.type"
                          labelName="label"
                          valueName="value"
                          omChange={handleGetSubReasons}
                          defaultValue="default_values"
                          disabled={true}
                        />
                      )}
                      defaultValue="default_values"
                      control={control}
                      name="protocol.reason_id.type"
                      disabled={true}
                      rules={{ required: 'Campo obrigatório' }}
                    />

                    <ErrorMessage
                      errors={errors}
                      name="protocol.reason_id.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Motivo',
                            value: 'reason_id'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="reason_id"
                        valueController={setValue}
                        fieldName="protocol.reason_id.label"
                        labelName="label"
                        valueName="value"
                        onChange={handleGetSubReasons}
                      />
                    )}
                    defaultValue="reason_id"
                    name="protocol.reason_id.label"
                    control={control}
                    disabled={field.isRequired}
                    rules={{ required: 'Campo obrigatório' }}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            dataOptions={reasons}
                            value={props.value}
                            valueController={setValue}
                            fieldName="protocol.reason_id.value"
                            labelName="label"
                            valueName="value"
                            isClearable={true}
                            closeMenuOnSelect={true}
                            portalTarget={true}
                            onChange={handleGetSubReasons}
                          />
                        )}
                        control={control}
                        name="protocol.reason_id.value"
                        defaultValue=""
                        rules={{ required: 'Campo obrigatório' }}
                      />

                      <ErrorMessage
                        errors={errors}
                        name="protocol.reason_id.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>

                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        title={'Excluir campo'}
                        disabled={field.isRequired}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'subreason_id') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={() => (
                        <FlexSelect
                          dataOptions={[
                            {
                              label: 'Valor padrão',
                              value: 'default_values'
                            }
                          ]}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value="default_values"
                          valueController={setValue}
                          fieldName="protocol.subreason_id.type"
                          labelName="label"
                          valueName="value"
                          defaultValue="default_values"
                          disabled={true}
                        />
                      )}
                      defaultValue={'default_values'}
                      control={control}
                      name="protocol.subreason_id.type"
                      rules={{ required: 'Campo obrigatório' }}
                      disabled={true}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.subreason_id.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Submotivo',
                            value: 'subreason_id'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="subreason_id"
                        valueController={setValue}
                        fieldName="protocol.subreason_id.label"
                        labelName="label"
                        valueName="value"
                      />
                    )}
                    name="protocol.subreason_id.label"
                    control={control}
                    disabled={field.isRequired}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            dataOptions={subReasons}
                            value={props.value}
                            valueController={setValue}
                            fieldName="protocol.subreason_id.value"
                            labelName="label"
                            valueName="value"
                            isClearable={true}
                            closeMenuOnSelect={true}
                            portalTarget={true}
                          />
                        )}
                        disabled={!subReasons.length && loadingSubReasons}
                        control={control}
                        name="protocol.subreason_id.value"
                        defaultValue=""
                        rules={{ required: 'Campo obrigatório' }}
                      />

                      <ErrorMessage
                        errors={errors}
                        name="protocol.subreason_id.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>

                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        title={'Excluir campo'}
                        disabled={field.isRequired}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'current_status') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={() => (
                        <FlexSelect
                          dataOptions={[
                            {
                              label: 'Valor padrão',
                              value: 'default_values'
                            }
                          ]}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value="default_values"
                          valueController={setValue}
                          fieldName="protocol.current_status.type"
                          labelName="label"
                          valueName="value"
                          defaultValue="default_values"
                          disabled={true}
                        />
                      )}
                      defaultValue="default_values"
                      control={control}
                      name="protocol.current_status.type"
                      rules={{ required: 'Campo obrigatório' }}
                      disabled={true}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.current_status.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Status',
                            value: 'current_status'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="current_status"
                        valueController={setValue}
                        fieldName="protocol.current_status.label"
                        labelName="label"
                        valueName="value"
                      />
                    )}
                    name="protocol.current_status.label"
                    control={control}
                    disabled={field.isRequired}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <Controller
                        render={(props) => (
                          <FlexSelect
                            dataOptions={status}
                            value={props.value}
                            valueController={setValue}
                            fieldName="protocol.current_status.value"
                            labelName="label"
                            valueName="value"
                            isClearable={true}
                            closeMenuOnSelect={true}
                            portalTarget={true}
                          />
                        )}
                        control={control}
                        name="protocol.current_status.value"
                        defaultValue=""
                        rules={{ required: 'Campo obrigatório' }}
                      />

                      <ErrorMessage
                        errors={errors}
                        name="protocol.current_status.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        disabled={field.isRequired}
                        size="sm"
                        title={'Excluir campo'}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          if (field.name === 'email') {
            return (
              <Row className="mb-3">
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={typeFieldsProtocol}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          valueController={setValue}
                          fieldName="protocol.email.type"
                          labelName="label"
                          valueName="value"
                        />
                      )}
                      control={control}
                      name="protocol.email.type"
                      rules={{ required: 'Campo obrigatório' }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="protocol.email.type"
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={[
                          {
                            label: 'Email',
                            value: 'email'
                          }
                        ]}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        value="email"
                        valueController={setValue}
                        fieldName="protocol.email.label"
                        labelName="label"
                        valueName="value"
                      />
                    )}
                    name="protocol.email.label"
                    control={control}
                    disabled={field.isRequired}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      {watch('protocol.email.type') === 'default_values' ? (
                        <Controller
                          as={Input}
                          type="email"
                          control={control}
                          name="protocol.email.value"
                          rules={{
                            validate: (value) => {
                              return (
                                emailRegex.test(value) ||
                                'Email com formato incorreto'
                              );
                            },
                            required: 'Campo obrigatório'
                          }}
                          defaultValue=""
                          onChange={(value) => {
                            handlerAddFieldProtocol(index, value);
                          }}
                        />
                      ) : (
                        <Controller
                          as={Input}
                          type="text"
                          name="protocol.email.value"
                          control={control}
                          disabled={
                            watch('protocol.email.type') === 'first_answer'
                          }
                          rules={
                            watch(`protocol.email.type`) !== 'first_answer' && {
                              required: 'Campo obrigatório'
                            }
                          }
                        />
                      )}

                      <ErrorMessage
                        errors={errors}
                        name="protocol.email.value"
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        disabled={field.isRequired}
                        title={'Excluir campo'}
                        onClick={() => {
                          !field.isRequired &&
                            window.confirm(
                              'Deseja realmente excluir esse campo?'
                            ) &&
                            handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            );
          }

          return (
            <>
              {isCustomFieldRender ? (
                <>
                  {setIsCustomFieldRender(false)} <hr />
                </>
              ) : null}
              <Row className="mb-3" key={index}>
                {selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL ? (
                  <Col md="4">
                    <Controller
                      render={(props) => (
                        <FlexSelect
                          dataOptions={typeFieldsProtocol}
                          isMulti={false}
                          closeMenuOnSelect={true}
                          value={props.value}
                          valueController={setValue}
                          fieldName={`protocol.${field.name}.type`}
                          labelName="label"
                          valueName="value"
                        />
                      )}
                      control={control}
                      name={`protocol.${field.name}.type`}
                      rules={{ required: 'Campo obrigatório' }}
                    />
                    <ErrorMessage
                      errors={errors}
                      name={`protocol.${field.name}.type`}
                      render={({ message }) => errorFormMessage(message)}
                    />
                  </Col>
                ) : null}
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <Controller
                    render={() => (
                      <FlexSelect
                        dataOptions={protocolFields.filter((fieldCurrent) => {
                          if (
                            !fieldCurrent.isSelected ||
                            fieldCurrent.name === field.name
                          )
                            return true;
                        })}
                        isDisabled={field.isRequired}
                        isMulti={false}
                        closeMenuOnSelect={true}
                        setValue={setValue}
                        value={field.name}
                        valueController={setValue}
                        fieldName={`protocol.${field.name}.label`}
                        labelName="label"
                        valueName="name"
                        onChange={(value) => {
                          handlerAddFieldProtocol(index, value);
                        }}
                      />
                    )}
                    name={`protocol.${field.name}.label`}
                    control={control}
                    disabled={field.isRequired}
                  />
                </Col>
                <Col
                  md={
                    selectedOption === TRANSFER_TO_DIALOG_TREE_WITH_PROTOCOL
                      ? '4'
                      : '6'
                  }
                >
                  <FieldValueProtocolTotalArea>
                    <FieldValueProtocolArea>
                      <HandlerBroadcastListProtocolCustomFields
                        field={field}
                        control={control}
                        optionsCustomFields={optionsCustomFields}
                        setValue={setValue}
                        index={index}
                        watch={watch}
                      />

                      <ErrorMessage
                        errors={errors}
                        name={`protocol.${field.name}.value`}
                        render={({ message }) => errorFormMessage(message)}
                      />
                    </FieldValueProtocolArea>
                    <ButtonDeleteFieldArea>
                      <Button
                        color="danger"
                        size="sm"
                        title={'Excluir campo'}
                        disabled={field.isRequired}
                        onClick={() => {
                          window.confirm(
                            'Deseja realmente excluir esse campo?'
                          ) && handlerRemoveFieldProtocol(index);
                        }}
                      >
                        <li className="fas fa-trash"></li>
                      </Button>
                    </ButtonDeleteFieldArea>
                  </FieldValueProtocolTotalArea>
                </Col>
              </Row>
            </>
          );
        })
      ) : (
        <Loading />
      )}

      <Row>
        <Col md="12" className="d-flex justify-content-end">
          <Button color="success" size="sm" onClick={handlerAddNewCustomField}>
            + Adicionar campos
          </Button>
        </Col>
      </Row>
    </div>
  );
};
